class Emitter {
    static topicInstances = new Map();
    constructor (options = {}, topic = 'default') {
        if (Emitter.topicInstances.has(topic)) {
            return Emitter.topicInstances.get(topic);
        }
        this._options = { ...options };
        this._events = new Map();
        Emitter.topicInstances.set(topic, this);
    }

    /**
     * options 返回参数
     * @returns {(Object)}
     */
    get options () {
        return this._options;
    }

    /**
     * 修改配置参数
     * @param options {Object}
     */
    config (options = {}) {
        this._options = { ...this._options, ...options };
    }

    /**
     * on 绑定事件
     * @param event {String} 事件名称
     * @param listener {(function(): void)} 监听器
     * @returns {(function(): void)|*} 解除监听方法
     */
    on (event, listener) {
        if (this._events.has(event) && this._events.has(`$type_${event}`)) {
            this._events.get(event).add(listener);
            this._events.get(`$type_${event}`).set(listener, '');
            return () => {
                this._events.get(event).delete(listener);
                this._events.get(`$type_${event}`).delete(listener);
            };
        }
        const listeners = new Set();
        const eventTypes = new Map();
        listeners.add(listener);
        eventTypes.set(listener, '');
        this._events.set(`$type_${event}`, eventTypes);
        this._events.set(event, listeners);
        return () => {
            return listeners.delete(listener);
        };
    }

    /**
     * once 一次性监听
     * @param event
     * @param listener
     */
    once (event, listener) {
        if (this._events.has(event) && this._events.has(`$type_${event}`)) {
            this._events.get(event).add(listener);
            this._events.get(`$type_${event}`).set(listener, 'once');
            return;
        }
        const listeners = new Set();
        const types = new Map();
        listeners.add(listener);
        types.set(`$type_${event}`, 'once');
        this._events.set(`$type_${event}`, types);
        this._events.set(event, listeners);
    }

    /**
     * off 解除监听
     * @param event {String} 事件名称
     * @param listener {(function(): void)} 监听器
     */
    off (event, listener) {
        if (this._events.has(event)) {
            this._events.get(event).delete(listener);
            if (this._events.has(`$type_${event}`)) {
                this._events.get(`$type_${event}`).delete(listener);
            }
        }
    }

    /**
     * emit 触发事件
     * @param event {String} 事件名称
     * @param params
     * @param {...any}
     */
    emit (event, ...params) {
        if (!this._events.has(event)) return;
        const listeners = this._events.get(event);
        const types = this._events.get(`$type_${event}`);
        Array.from(listeners).forEach((fn) => {
            if (typeof fn === 'function') {
                fn(...params);
            }
            if (!!types && types.has(fn) && types.get(fn) === 'once') {
                listeners.delete(fn);
            }
        });
    }

    /**
     * destroy 对象销毁
     * destroy
     * @returns {void}
     */
    destroy () {
        this._options = {};
        this._events.clear();
    }
}

const emitter = new Emitter();

export { emitter, Emitter };
